const SKIP_FORM_FIELDS = new Set([
  'action',
  'button_confirm',
  'formHtml',
  'webview',
  'paymentUrl',
  'url',
  'redirectUrl',
  'secureHashSecret'
]);

/**
 * Redirect the browser to PayDollar / PesoPay using the gateway payload from addToCart.
 * Supports direct URLs, pre-rendered form HTML, and OpenCart field maps with `action`.
 */
export function redirectToPayDollar(gateway) {
  if (!gateway) {
    return { ok: false, error: 'Missing PayDollar redirect payload' };
  }

  const redirectUrl = gateway.paymentUrl || gateway.url || gateway.redirectUrl;
  if (redirectUrl) {
    window.location.href = redirectUrl;
    return { ok: true };
  }

  if (gateway.formHtml || gateway.webview) {
    const container = document.createElement('div');
    container.innerHTML = gateway.formHtml || gateway.webview;
    document.body.appendChild(container);
    const form = container.querySelector('form');
    if (form) {
      form.submit();
      return { ok: true };
    }
  }

  if (gateway.action) {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = gateway.action;
    form.style.display = 'none';

    for (const [key, value] of Object.entries(gateway)) {
      if (SKIP_FORM_FIELDS.has(key) || value == null) continue;
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = String(value);
      form.appendChild(input);
    }

    document.body.appendChild(form);
    form.submit();
    return { ok: true };
  }

  return { ok: false, error: 'Unable to redirect to PayDollar' };
}
